/* app/js/src/components/content-control/studio/content-control-studio/content-control-studio-subtitle-editor/content-control-studio-subtitle-editor.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  min-width: 400px;
  width: 400px;
  height: max-content;
  min-height: 260px;
}
:host ::ng-deep * {
  -webkit-user-select: none;
  user-select: none;
}
.container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 5px;
  margin: 10px 0;
  height: max-content;
  min-height: 210px;
}
.container .segment {
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: space-around;
}
.container .segment .row {
  color: rgba(0, 0, 0, 0.54);
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Open Sans";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.container .segment .row span {
  font-weight: 700;
  text-decoration-line: underline;
}
.container .segment .row textarea {
  width: 100%;
  resize: vertical;
  overflow: auto;
}
.container .segment .row textarea[dir=rtl] {
  unicode-bidi: bidi-override;
}
/*# sourceMappingURL=content-control-studio-subtitle-editor.component.css.map */
